export const GetWindTurbine = "GetWindTurbine";
export const GetWindTurbineSuccess = "GetWindTurbineSuccess";
export const GetWindTurbineError = "GetWindTurbineError";
export const GetWindTurbines = "GetWindTurbines";
export const GetWindTurbinesSuccess = "GetWindTurbinesSuccess";
export const GetWindTurbinesError = "GetWindTurbinesError";
